<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="CASH_CALL_REASON_OPTIONS"       
      label="Cash Call Reason"
      :displayType="displayflex"
      size="sm"
      rules="required"
    >
      <template v-slot:label>Cash Call Reason <span class="text-danger">*</span> </template>
  
      <template v-slot:first>
        <b-form-select-option value="" disabled
          >Select</b-form-select-option
        >        
      </template>
      <!-- override error slot -->
      <template #error="{ errors }">
          <div
            v-if="showErrors && errors.length"
            class="invalid-feedback d-block"
          >
            {{ errors[0] }}
          </div>
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { CASH_CALL_REASON_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallReason',
    components: {
      BaseSelect
    },
    props: {
      value: String,
      displayType: String,
      showErrors: {
        type: Boolean,
        default: false
      }
    },
    emits: ['input'],
    setup(props, { emit }) {

      const displayflex = "dropdownWidth-md"
  
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        CASH_CALL_REASON_OPTIONS,  
        modelValue,
        displayflex
      }
    }
  })
  </script>
  